import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usersKeys } from '../../users';
import { telegramLogin } from '../auth.service';
export const useTelegramLogin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: telegramLogin,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: usersKeys.user('me') });
        },
    });
};
